enum CustomerElectonicAddressType {
  EMAIL = 'EMAIL',
}

export default CustomerElectonicAddressType;
